import { House, Library, Search } from 'lucide-react'

export const NAV_ITEMS = [
  { to: '/', label: 'Home', icon: House, paths: ['/', '/daylists'] },
  { to: '/library', label: 'Library', icon: Library, paths: ['/library', '/playlists'] },
  { to: '/search', label: 'Search', icon: Search, paths: ['/search'] },
] as const

export function isNavItemActive(item: (typeof NAV_ITEMS)[number], pathname: string): boolean {
  return item.paths.some((path) => pathname === path || pathname.startsWith(`${path}/`))
}
